import ABCyaPhaser from '@abcya/abcya_phaser'
import FontKeys from '../FontKeys';
import gameData from '../gameData';

export default class NavBar extends Phaser.GameObjects.Container
{
    constructor(scene)
    {
        super(scene);
        scene.add.existing(this);

        this.scene = scene;

        this.livesArr = [];

        this.createNav();
        this.setLives();
    };

    createNav()
    {
        this.scorePanel =  ABCyaPhaser.Images.addImage(0, 0, gameData.DESKTOP ?"navBar" : "navBarM", this);
        this.lifeLabel = ABCyaPhaser.Text.addText(-443,-3,28, 0xb73a37, FontKeys._curse_casualregular, ABCyaPhaser.Localization.instance.getLocalizedString("game_screen.life_label"), this);
        this.scoreLabel = ABCyaPhaser.Text.addText(-53,-2,24, 0xb73a37, FontKeys._curse_casualregular, ABCyaPhaser.Localization.instance.getLocalizedString("game_screen.score_label"), this);
        if(!gameData.DESKTOP){
          this.lifeLabel.setFontSize(26).setPosition(-346,-2)
          this.scoreLabel.setFontSize(22).setPosition(15, -2);
          ABCyaPhaser.Text.resizeFontToFitWidth(this.lifeLabel, 48);
          ABCyaPhaser.Text.resizeFontToFitWidth(this.scoreLabel, 48);
        }
        else {
          ABCyaPhaser.Text.resizeFontToFitWidth(this.lifeLabel, 52);
          ABCyaPhaser.Text.resizeFontToFitWidth(this.scoreLabel, 52);
        }

        this.soundBtn = ABCyaPhaser.Buttons.addSimpleButton(this.scorePanel.width/2 - 60, -3, "btnSound", null, ()=>{
            this.toggleSound();
        }, this).setEnabled(false);
        this.muteBtn = ABCyaPhaser.Buttons.addSimpleButton(this.scorePanel.width/2 - 60, -3, "btnMute", null, ()=>{
            this.toggleSound();
        }, this).setEnabled(false);
        this.helpBtn = ABCyaPhaser.Buttons.addSimpleButton(this.soundBtn.x - this.soundBtn.width - 20, -3, "btnHelp", null, ()=>{
            this.helpBtn.setEnabled(false);
            this.showPopup();
        }, this).setEnabled(false);

        const newX = gameData.DESKTOP ? 60 : 120;
        this.scoreTxt = ABCyaPhaser.Text.addText(newX, -1, 35, "0xFFFFFF", FontKeys._curse_casualregular, String(gameData.SCORE), this);

        //position all the elements of the nav bar
        if(gameData.MUTE){
            this.muteBtn.visible = true;
            this.soundBtn.visible = false;
        } else {
            this.muteBtn.visible = false;
            this.soundBtn.visible = true;
        }

        this.setPosition(this.scene.mid.x, -this.scorePanel.height/2);

        //tween in the nav bar then start the clock
        ABCyaPhaser.Tweens.addTween(this, 1000, {y:this.scorePanel.height/2}, Phaser.Math.Easing.Quadratic.Out, ()=>{ this.navReady(); });
    };

    navReady()
    {
        this.helpBtn.setEnabled(true);
        if(gameData.MUTE == true){
            this.muteBtn.setEnabled(true);
            this.soundBtn.setEnabled(false);

            this.muteBtn.visible = true;
            this.soundBtn.visible = false;
        } else {
            this.muteBtn.setEnabled(false);
            this.soundBtn.setEnabled(true);

            this.muteBtn.visible = false;
            this.soundBtn.visible = true;
        }
    };

    disableNav()
    {
        this.soundBtn.setEnabled(false);
        this.muteBtn.setEnabled(false);
        this.helpBtn.setEnabled(false);
    };

    enableNav()
    {
        this.helpBtn.setEnabled(true);

        if(gameData.MUTE == true){
            this.muteBtn.setEnabled(true);
            this.soundBtn.setEnabled(false);

            this.muteBtn.visible = true;
            this.soundBtn.visible = false;
        } else {
            this.muteBtn.setEnabled(false);
            this.soundBtn.setEnabled(true);

            this.muteBtn.visible = false;
            this.soundBtn.visible = true;
        }
    }

    showPopup(){
        //start the clock and add button listeners
        ABCyaPhaser.Audio.playOneShot("Click", this.scene);

        this.scene.showPopup();
    };

    toggleSound(){
        ABCyaPhaser.Audio.playOneShot("Click", this.scene);

        //If the sound btn is showing, mute all sounds and show mute btn
        if(gameData.MUTE == false){
            // console.log("Sound muted");
            gameData.MUTE = true;

            this.muteBtn.setEnabled(true);
            this.soundBtn.setEnabled(false);

            this.muteBtn.visible = true;
            this.soundBtn.visible = false;

            this.scene.sound.setVolume(0);
        } else {
            // console.log("Sound on");
            gameData.MUTE = false;

            this.muteBtn.setEnabled(false);
            this.soundBtn.setEnabled(true);

            this.muteBtn.visible = false;
            this.soundBtn.visible = true;

            this.scene.sound.setVolume(1);
        }
    };

    setLives(){
        this.removeLives();
        //changes the position of the level circle
        if(gameData.LIVES >= 0){
            for(let l = 0; l < gameData.LIVES; l++){
                const lives = ABCyaPhaser.Images.addImage(0, 0, "ghostMini", this);
                this.livesArr.push(lives);

                const newX = gameData.DESKTOP ? -this.scorePanel.width/2 + 125 + ((lives.width/2 + 30) * l) : -this.scorePanel.width/2 + 95 + ((lives.width/2 + 25) * l);
                lives.setPosition(newX, -3);
            }
        }
    };

    setScore(type){
        let newScore;

        if(this.scoreTxt){
            this.scoreTxt.destroy();
            this.scoreTxt = null;
        }

        if(type === "+"){
            //console.log("adding");
            gameData.SCORE = gameData.SCORE + 100;
            newScore = gameData.SCORE;
        }
        if(type === "-"){
            //console.log("subtracting");
            gameData.SCORE = gameData.SCORE - 200;

            if(gameData.SCORE < 0){
                gameData.SCORE = 0;
            }

            newScore = gameData.SCORE;
        }
        if(type === "--"){
            //console.log("subtracting");
            gameData.SCORE = gameData.SCORE - 300;

            if(gameData.SCORE < 0){
                gameData.SCORE = 0;
            }

            newScore = gameData.SCORE;
        }

        const newX = gameData.DESKTOP ? 60 : 120;
        this.scoreTxt = ABCyaPhaser.Text.addText(newX, 0, 35, "0xFFFFFF", FontKeys._curse_casualregular, String(newScore), this);
    };

    removeLives(){
        //changes the position of the level circle
        for(var l = 0; l < this.livesArr.length; l++){
            this.livesArr[l].destroy();
        }
        this.livesArr = [];
    };
}